import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestStockAdjust from './request/requestStockAdjust'

const Actions = {
  // SAD01 在庫調整登録
  registerStockAdjust: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestStockAdjust.request.createRequest(params, rootGetters)
    return await axios
      // .get(apiMock.STOCK_ADJUST)
      .post(api.STOCK_ADJUST, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SAD02 在庫調整一覧取得
  getStockAdjustListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const ret = await axios
      // .get(apiMock.STOCK_ADJUST_LIST)
      .get(api.STOCK_ADJUST_LIST, { params: params })
      .then((response) => {
        const path = mutationsTypes.STOCK_ADJUST_SET_STOCK_ADJUST_LIST
        commit(path, response.data)

        // ページャーをセット
        const pagePath = mutationsTypes.UI_SET_PAGE_COUNT
        const pageCount = commonUtil.getPageCount(
          response.data.meta.totalRows,
          response.data.meta.perPage
        )
        commit(
          `UI/${pagePath}`,
          { length: pageCount, key: 'storageAdjustHistory' },
          { root: true }
        )

        const getData = getters.getStockAdjustListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SAD03 在庫調整キャンセル
  cancelStockAdjust: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.STOCK_ADJUST_CANCEL)
      .patch(`${api.STOCK_ADJUST_CANCEL}/${params.stockAdjustId}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SAD04 在庫調整履歴微調整
  editStockAdjust: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    return await axios
      // .get(apiMock.STOCK_ADJUST)
      .patch(`${api.STOCK_ADJUST}/${params.stockAdjustId}`, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
